module.exports = __webpack_public_path__ + "img/wraina.915c84b6.png";